import InvestorInterface from "./investor";
import ManagerInterface from "./manager";

export default interface CompanyInterface {
    id: string;
    email:string;
    country: string;
    updatedDate:string;
    name: string;
    investors: InvestorInterface[];
    managers:ManagerInterface[];
  }
  
  const companyInitialValue: CompanyInterface = {
    id: String(),
    email:String(),
    updatedDate: String(),
    name: String(),
    country: String(),
    investors: [],
    managers:[]
  };

  
  export { companyInitialValue };
  